export default __webpack_public_path__ + "static/media/redright.f468a253.svg";